import { MessageModel } from '@/types/message';

/** True when `messages` already contains this exact kind+id pair (server may reuse ids across kinds). */
export function messagesContainMessage(messages: Array<MessageModel>, message: MessageModel): boolean {
  return messages.some((entry) => entry.id === message.id && entry.kind === message.kind);
}

export function addMissingMessage(messages: Array<MessageModel>, newMessage: MessageModel): Array<MessageModel> {
  return messagesContainMessage(messages, newMessage) ? messages : [...messages, newMessage];
}

/**
 * Compares two message arrays to determine if they have the same content.
 * Returns true if the messages are equivalent (same kind+id pairs in the same order).
 */
export function areMessagesEqual(currentMessages: Array<MessageModel>, newMessages: Array<MessageModel>): boolean {
  if (currentMessages.length !== newMessages.length) {
    return false;
  }

  return currentMessages.every((msg, index) => msg.id === newMessages[index].id && msg.kind === newMessages[index].kind);
}
